/* @flow */
import {getContentLang} from '../utilities/lang';
import ListenerManager from '../utilities/ListenerManager';
import {select} from '../utilities/select';
import type {Module} from '../types';

const listeners: ListenerManager = new ListenerManager;

if (process.env.NODE_ENV === 'development') {
  if (typeof window.ga === 'undefined') {
    window.ga = (...args) => {
      /* eslint-disable no-console */
      console.log('Called GA:', args);
    };
  }
}

/**
 * Record a form submission event.
 *
 * @param {HTMLFormElement} formElement
 * @param {string} category - Typically the object that was interacted with
 * @param {string} [label] - Useful for categorizing events
 */
const recordFormSubmit: Function = (
  formElement: HTMLFormElement,
  category: string,
  label: ?string
): void => {
  listeners.add(formElement, 'submit', (e: Event) => {
    e.preventDefault();
    let submitted: boolean = false;
    const submitForm: Function = (): void => {
      if (!submitted) {
        submitted = true;
        formElement.submit();
      }
    };

    setTimeout(submitForm, 1000);
    window.ga('send', 'event', {
      eventCategory: category,
      eventAction: 'submit',
      eventLabel: label,
      hitCallback: submitForm
    });
  });
};

/**
 * Record an embedded video play event.
 *
 * @param {HTMLElement} videoElement
 * @param {string} [label] - Useful for categorizing events
 */
const recordVideoPlay: Function = (
  videoElement: HTMLElement,
  label: ?string
): void => {
  listeners.add(videoElement, 'click', () => {
    window.ga('send', 'event', {
      eventCategory: 'Video',
      eventAction: 'play',
      eventLabel: label
    });
  });
};

const analytics: Module & {
  sendPageview: () => void
} = {
  init(): void {
    this.destroy();

    if (typeof window.ga === 'undefined') {
      /* eslint-disable no-console */
      console.info('Analytics events disabled.');
      return;
    }

    const newsletterForm: ?HTMLElement = select('form.js-newsletter-form');
    if (newsletterForm instanceof HTMLFormElement) {
      recordFormSubmit(newsletterForm, 'Signup Form', 'WesLife Newsletter');
    }

    const homepageVideo: ?HTMLElement = select('.js-homepage-video');
    if (homepageVideo instanceof HTMLElement) {
      recordVideoPlay(homepageVideo, 'Homepage');
    }
  },
  sendPageview(): void {
    if (typeof window.ga !== 'undefined') {
      window.ga('send', {
        hitType: 'pageview',
        page: location.pathname + location.search,
        'dimension1': getContentLang()
      });
    }
  },
  destroy(): void {
    listeners.removeAll();
  }
};

export default analytics;



// WEBPACK FOOTER //
// ./resources/assets/magazine/js/magazine/analytics.js